/* ── OLIER THEME JS ── */

/* Scroll reveal */
(function () {
  const ro = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('up'); ro.unobserve(e.target); } });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(el => ro.observe(el));
})();

/* Mobile menu */
function openMenu()  { document.getElementById('mobile-menu').classList.add('open'); }
function closeMenu() { document.getElementById('mobile-menu').classList.remove('open'); }

/* Accordion */
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.accordion-trigger');
  if (!trigger) return;
  const body   = trigger.nextElementSibling;
  const isOpen = trigger.classList.contains('open');
  trigger.closest('.accordion').querySelectorAll('.accordion-trigger').forEach(b => {
    b.classList.remove('open');
    const bd = b.nextElementSibling;
    if (bd) { bd.style.maxHeight = null; bd.classList.remove('open'); }
  });
  if (!isOpen) {
    trigger.classList.add('open');
    body.style.maxHeight = body.scrollHeight + 'px';
    body.classList.add('open');
  }
});

/* Colour swatch selection */
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.pdp-swatch');
  if (!swatch) return;
  const group = swatch.closest('.pdp-swatches');
  group.querySelectorAll('.pdp-swatch').forEach(s => s.classList.remove('active'));
  swatch.classList.add('active');
  const nameEl = document.getElementById('selected-colour');
  if (nameEl) nameEl.textContent = swatch.dataset.colour || '';
  syncVariant();
});

/* Size button selection */
document.addEventListener('click', function (e) {
  const sizeBtn = e.target.closest('.pdp-size-btn');
  if (!sizeBtn) return;
  const group = sizeBtn.closest('.pdp-sizes');
  group.querySelectorAll('.pdp-size-btn').forEach(b => b.classList.remove('active'));
  sizeBtn.classList.add('active');
  syncVariant();
});

/* Sync selected variant to Shopify form */
function syncVariant() {
  const variantData = window.__variantData;
  if (!variantData) return;

  const activeSwatch = document.querySelector('.pdp-swatch.active');
  const activeSizeBtn = document.querySelector('.pdp-size-btn.active');
  const selectedColour = activeSwatch ? activeSwatch.dataset.colour : null;
  const selectedSize   = activeSizeBtn ? activeSizeBtn.dataset.size : null;

  let matched = null;
  for (const v of variantData) {
    const colourOk = !selectedColour || v.options.some(o => o.toLowerCase() === selectedColour.toLowerCase());
    const sizeOk   = !selectedSize   || v.options.some(o => o === selectedSize);
    if (colourOk && sizeOk && v.available) { matched = v; break; }
    if (colourOk && sizeOk && !matched)    { matched = v; }
  }

  const idInput  = document.getElementById('variant-id');
  const addBtn   = document.querySelector('.pdp-add');
  const priceEl  = document.getElementById('product-price');

  if (matched) {
    if (idInput)  idInput.value = matched.id;
    if (priceEl)  priceEl.textContent = formatMoney(matched.price);
    if (addBtn) {
      addBtn.disabled = !matched.available;
      addBtn.textContent = matched.available ? 'Add to Bag' : 'Sold Out';
    }
  }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2) + ' AUD';
}

/* Cart quantity controls */
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('[data-cart-qty]');
  if (!btn) return;
  const key   = btn.dataset.cartQty;
  const delta = parseInt(btn.dataset.delta, 10);
  const input = document.querySelector(`[data-qty-key="${key}"]`);
  if (!input) return;
  const newQty = Math.max(0, parseInt(input.value, 10) + delta);
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  });
  location.reload();
});

/* Init on load */
document.addEventListener('DOMContentLoaded', function () {
  syncVariant();
});
